import { useState, useEffect, useCallback } from 'react';
import { api } from '../lib/api';
import { ResourceRate, ResourceSlug } from '../types/admin';

interface RatesResponse {
  success: boolean;
  data: ResourceRate[];
}

interface RateResponse {
  success: boolean;
  data: ResourceRate;
}

export function useOrgResourceRates(orgId: string) {
  const [rates, setRates] = useState<ResourceRate[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    api
      .get<RatesResponse>(`/org-admin/${orgId}/rates`)
      .then(res => {
        if (!cancelled) {
          setRates(res.data);
          setLoading(false);
        }
      })
      .catch(err => {
        if (!cancelled) {
          setError(err instanceof Error ? err.message : 'Failed to load resource rates');
          setLoading(false);
        }
      });
    return () => { cancelled = true; };
  }, [orgId]);

  const updateRate = useCallback(
    async (slug: ResourceSlug, hourlyRate: number) => {
      const res = await api.patch<RateResponse>(`/org-admin/${orgId}/rates/${slug}`, { hourlyRate });
      setRates(prev => prev.map(r => r.slug === slug ? res.data : r));
      return res.data;
    },
    [orgId],
  );

  return { rates, loading, error, updateRate };
}
